// Workaround for Memberr's app proxy page (build-a-box under /apps/memberr/...). Shopify returns
// `sections: null` from the cart API there, which crashes the cart drawer re-render in theme.js.
// This refetches the sections from the shop root, where section rendering works, and re-dispatches
// the event with them

function collectBundledSectionIds() {
	const sectionIds = new Set();
	document.documentElement.dispatchEvent(
		new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionIds } }),
	);
	return [...sectionIds];
}

async function fetchSections(sectionIds) {
	try {
		const response = await fetch(`${Shopify.routes.root}?sections=${sectionIds.join(',')}`);
		if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
		return await response.json();
	} catch (error) {
		console.error('cart-sections-fallback: fetchSections failed:', error);
		return null;
	}
}

async function onCartChange(event) {
	const cart = event.detail?.cart;
	if (!cart || cart.sections) return;
	event.stopImmediatePropagation();

	const sectionIds = collectBundledSectionIds();
	const sections = sectionIds.length ? await fetchSections(sectionIds) : null;
	// A 200 response can still contain null for a section that failed to render
	const hasAllSections = sectionIds.length > 0 && sectionIds.every((id) => sections?.[id]);

	if (!hasAllSections) {
		document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
		return;
	}

	document.documentElement.dispatchEvent(
		new CustomEvent('cart:change', {
			bubbles: true,
			detail: { ...event.detail, cart: { ...cart, sections } },
		}),
	);
}

const isMemberrProxyPage = window.location.pathname.includes('/apps/memberr');

if (isMemberrProxyPage) {
	window.addEventListener('cart:change', onCartChange, { capture: true });
}
